module.exports = __webpack_public_path__ + "img/logo.30935f5d.png";